import { render, staticRenderFns } from "./Vettori.vue?vue&type=template&id=b7ebb61e&"
import script from "./Vettori.vue?vue&type=script&lang=js&"
export * from "./Vettori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports